import React, { useEffect, useState } from "react";
import { Button, Row, Col, ListGroup, Card, Container } from "react-bootstrap";
import { Image } from "cloudinary-react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Message from "../components/message";
import CheckoutSteps from "../components/checkoutSteps";
import { addDecimals } from "../Utils/addDecimals";
import { createOrder, createSessionCheckoutWithStripe } from "../actions/order";
import { paymentDecode } from "../Utils/paymentDecode";
import { useStripe } from "@stripe/react-stripe-js";

const PlaceOrderScreen = ({ history }) => {
  // Get states from redux
  // Cart Reducer
  const [buttonLoading, setButtonLoading] = useState(false);
  const [stripeError, setStripeError] = useState(false);

  const cart = useSelector((state) => state.cart);
  const { cartItems, shippingAddress, paymentMethod, userShippingInfo } = cart;
  const { address1, address2, city, country } = shippingAddress;

  // Order Reducer
  const orderCreate = useSelector((state) => state.orderCreate);
  const { order, success, error } = orderCreate;

  // Stripe Order Session
  const checkoutWithStripe = useSelector((state) => state.checkoutWithStripe);
  const { session, sessionId, sessionError } = checkoutWithStripe;

  cart.itemsPrice = Number(
    addDecimals(
      cart.cartItems.reduce(
        (acc, curr) => (curr.price - curr.discount) * curr.qty + acc,
        0
      )
    )
  );

  // EDIT THE SHIPPING ARRANGEMENT
  cart.shippingCost = Number(addDecimals(0));
  cart.tax = Number(addDecimals(0));
  cart.totalPrice = Number(cart.itemsPrice + cart.shippingCost + cart.tax);

  const dispatch = useDispatch();
  const stripe = useStripe();

  const stripeSessionHandler = () => {
    const line_items = order.orderItems.map((item) => {
      return {
        price_data: {
          currency: "usd",
          product_data: {
            name: item.name,
            description: item.description
              ? item.description
              : "No description available",
            images: item.image[0],
          },
          unit_amount: (item.price - item.discount) * 100,
        },
        quantity: item.qty,
      };
    });

    dispatch(
      createSessionCheckoutWithStripe(
        line_items,
        order.user.email,
        [paymentDecode(order.paymentMethod)],
        order._id,
        order.shippingCost,
        order.tax,
        "usd"
      )
    );
  };

  useEffect(() => {
    if (!shippingAddress || !userShippingInfo) {
      history.push("/shipping");
    }
    if (success) {
      setTimeout(() => {
        stripeSessionHandler();
      }, 1000);
    }
  }, [
    dispatch,
    history,
    cart,
    success,
    shippingAddress,
    userShippingInfo,
    order,
  ]);

  useEffect(() => {
    if (session) {
      setButtonLoading(true);
    }

    if (sessionError) {
      setButtonLoading(false);
    }
    if (sessionId) {
      const { error } = stripe.redirectToCheckout({
        sessionId,
      });
      if (error) {
        setStripeError(true);
      }
    }
  }, [
    dispatch,
    history,
    order,

    sessionId,
    session,
    stripe,
    // paypalSuccess,
    sessionError,
  ]);

  // TO: EDIT THE CURRENCY
  const placeOrderHandler = async () => {
    dispatch(
      createOrder({
        user: userShippingInfo,
        orderItems: cart.cartItems,
        shippingAddress: cart.shippingAddress,
        paymentMethod: paymentMethod,
        shippingCost: cart.shippingCost,
        tax: cart.tax,
        totalPrice: cart.totalPrice,
        itemsPrice: cart.itemsPrice,
        currency: "USD",
        trackingNumber: "",
      })
    );
  };

  return (
    <Container>
      <CheckoutSteps step1 step2 step3 />
      {error && <Message variant="danger">{error}</Message>}
      {success && (
        <Message variant="success">
          {"Shipping Information checks out! Proceed to payment"}
        </Message>
      )}
      <Row>
        <h1>Order Summary</h1>
        <Col md={9}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>SHIPPING</h2>
              <p>
                <strong>Address:</strong>
                {` ${address1}, ${address2}, ${city}, ${country}`}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Payment Method</h2>
              <strong>Method: </strong>
              {paymentMethod}
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Order Items</h2>
              {cartItems.length === 0 ? (
                <Message variant="danger">Your cart is empty</Message>
              ) : (
                <ListGroup variant="flush">
                  {cartItems.map((item, index) => {
                    return (
                      <ListGroup.Item key={index}>
                        <Row
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <Col
                            style={{
                              width: "100px",
                            }}
                          >
                            <Image
                              className="img-thumbnail"
                              cloudName={"dljielsye"}
                              publicId={item.image[0]}
                              alt={item.name}
                              // width={50}
                              style={{
                                width: "100%",
                                height: "120px",
                                objectFit: "contain",
                                display: "flex",
                                justifyContent: "center",
                              }}
                              fluid
                            />
                          </Col>
                          <Col>
                            <Link
                              to={`/product/${item.productId}`}
                              style={{
                                textDecoration: "none",
                                color: "#0d6efd",
                              }}
                            >
                              {item.name}
                            </Link>
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Capacity
                            </h4>{" "}
                            {item.capacity} GB
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Color
                            </h4>{" "}
                            {item.color}
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Price
                            </h4>{" "}
                            ${item.price - item.discount}
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Quantity
                            </h4>{" "}
                            {item.qty}
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Total
                            </h4>{" "}
                            ${(item.price - item.discount) * item.qty}
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    );
                  })}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>

        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Order Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>ITEMS</Col>
                  <Col>${cart.itemsPrice}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Tax</Col>
                  <Col>${cart.tax}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>${cart.totalPrice}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <span className="d-grid gap-2">
                  <Button
                    type="button"
                    disabled={
                      cartItems.length === 0 || success || buttonLoading
                    }
                    style={{
                      backgroundColor: "black",
                      color: "white",
                      border: "1px solid black",
                      textAlign: "center",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#514f4f";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "black";
                      e.target.style.color = "white";
                    }}
                    onClick={placeOrderHandler}
                  >
                    Proceed to Payment
                  </Button>
                </span>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PlaceOrderScreen;
